module.exports = __webpack_public_path__ + "static/img/2.94d4594.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/2.png
// module id = z8+z
// module chunks = 216